export const MultiSelect = "MultiSelect";

export const userTypes = {
  user: "user",
  admin: "admin",
  restaurant: "restaurant",
};

export const reservationStatus = {
  cancelled: "cancelled",
  pending: "pending",
  accepted: "accepted",
  done: "done",
};
